import {call, put} from "redux-saga/effects";
import { SDK } from "../../../sdk";
import {setPaymentsIsReady} from "../actions";
import processPendingPurchases from "./processPendingPurchases";

function waitForPaymentsSdk() {
    return SDK.instance.paymentsReady();
}

export default function* checkIfAvailable() {
    yield waitForPaymentsSdk();

    yield put(setPaymentsIsReady());

    yield call(processPendingPurchases);
}